// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-control:disabled.date__time--format.disabled_cursor,\n.form-control[readonly].date__time--format.disabled_cursor {\n  background-color: #f7f7f7;\n}", ""]);
// Exports
module.exports = exports;
